import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { ja } from 'vuetify/locale'

import { aliases, mdi } from 'vuetify/iconsets/mdi'

export default createVuetify({
  components,
  directives,

  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },

  locale: {
    locale: 'ja',
    fallback: 'en',
    messages: { ja },
  },

  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: "#029ec0",
          secondary: "#ff9800",
          accent: '#8c9eff',
          error: '#FF3F3A',
          lighten1: '#FFE1E0',
        },
      },
    },
  },
})